var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-364 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2408",
    "data-name": "Rectangle 2408",
    width: 32,
    height: 32,
    rx: 10,
    transform: "translate(364 98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M53.893,16.013a2.01,2.01,0,0,0-2.826,0L44.483,22.6,37.9,16.013a2,2,0,0,0-2.826,2.828l6.584,6.589-6.584,6.589a2.014,2.014,0,0,0,0,2.828,1.994,1.994,0,0,0,2.826,0l6.584-6.589,6.584,6.589a1.994,1.994,0,0,0,2.826,0,2.014,2.014,0,0,0,0-2.828l-6.584-6.589,6.584-6.589a1.966,1.966,0,0,0,0-2.828Z",
    transform: "translate(335.508 88.567)",
    fill: "#73217d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.869956a84c2ad74ed70af7f7a8013580.svg";
export { ForwardRef as ReactComponent };